export class ContractDurationType {
    readonly contractDurationTypeId: number;
    readonly contractDurationTypeName: string;

    protected constructor(
        contractDurationTypeId: number,
        contractDurationTypeName: string
    ) {
        this.contractDurationTypeId = contractDurationTypeId;
        this.contractDurationTypeName = contractDurationTypeName;
    }

    public static Days = new ContractDurationType(10, "Days");
    public static Months = new ContractDurationType(20, "Months");
    public static Years = new ContractDurationType(30, "Years");

    public static asArray = () => [
        ContractDurationType.Days,
        ContractDurationType.Months,
        ContractDurationType.Years,
    ];

    public static fromId = (id: number) =>
        ContractDurationType.asArray().find(
            t => t.contractDurationTypeId === id
        );
}
